<template>
  <ul class="info-list-box">
    <li v-for="(item, index) in infoList" :key="index"><a @click="handleClick(item)">{{ item.newsTitle }}</a><span v-if="!hiddenDate">[{{ item.date }}]</span></li>
  </ul>
</template>

<script>
import { parseTime } from '@/utils/ruoyi'

export default {
  name: "InfoList",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    hiddenDate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      infoList: []
    }
  },
  watch: {
    list: {
      immediate: true,
      handler(newVal) {
        this.infoList = newVal.map(item => ({
          ...item,
          date: parseTime(item.newsCreateTime, "{m}-{d}") || "",
        }))
      },
      deep: true
    }
  },
  methods: {
    handleClick(item) {
      this.$router.push({
        path: `/index/info/${item.id}`,
        query: {
          linkMenuId: item?.newsMenuId || ""
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.info-list-box {
  overflow: hidden;
  width: 100%;

  li {
    background: url("../../../assets/images/dian.png") no-repeat center left;
    display: block;
    height: 32px;
    padding-left: 20px;
    line-height: 32px;
    border-bottom: 1px dashed #ddd;
    display: flex;
    justify-content: space-around;

    a {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        color: #fcc200;
      }
    }

    span {
      text-align: right;
      font-size: 12px;
      width: 45px;
      overflow: hidden;
      color: #777;
    }
  }
}
</style>